/**
 * Entrance Scene
 *
 * The first scene visitors encounter.
 * Sets the tone: dark, mysterious, inviting exploration.
 */

import type { Scene } from '@/types/scene';

export const entrance: Scene = {
  id: 'entrance',
  name: 'The Entrance',
  atmosphere: {
    background: '#0a0a0f',
    backgroundImage: '/images/landing.webp',
    fogIntensity: 0.2,
  },
  interactions: [
    {
      id: 'enter-door',
      target: '.door-enter',
      action: { type: 'navigate', sceneId: 'hallway' },
      hint: 'Enter...',
    },
    {
      id: 'moon-gaze',
      target: '.moon',
      action: { type: 'secret', secretId: 'moon-whisper' },
    },
  ],
  transitions: [{ to: 'hallway', effect: 'fade', duration: 1200 }],
  secrets: [
    {
      id: 'moon-whisper',
      trigger: 'click',
      content: 'The moon remembers what the city forgets.',
      persistent: true,
    },
  ],
};
